export const getRatingsRowCount = (topRating: number) => {
  if (topRating > 50) return 50
  if (topRating < 5) return 5

  return topRating
}
